<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.subscribers', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <!-- <div class="card-title">
                    <router-link :to="{ name: 'add-patient' }" >
                        {{ $t('message.addPatient') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div> -->


                    <b-container>
                <div class="d-flex justify-content-center" v-if="testAutomatique">
                    <div class="loading"></div>
                </div>
                <b-row class="justify-content-sm-center">
                    <div v-if="!paiementReussi">
                        <p>{{ $t('message.dejaom') }}
                            <button color="btn btn-primary primary " small @click="checkStatutPaiement">Oui</button>
                        </p>
                        <div v-if="testAutomatique">
                            <p>{{ $t('message.verification') }} {{nbreSecondes}} secondes</p>
    <!--                         <b-progress-linear
                                v-model="intervale"
                                height="25"
                            >
                                <strong>{{ Math.ceil(intervale) }}%</strong>
                            </b-progress-linear> -->
                            <strong>{{ Math.ceil(intervale) }}%</strong>
                        </div>

                            <button class="btn btn-primary primary"  small @click="procederAuPaiement">
                                {{ $t('message.initier') }}
                            </button>
                    </div>
                    <div v-else>
                        {{ $t('message.merci') }}
                    </div>
                </b-row>
            </b-container>
        </div>
        </div>
    </div>
</template>

<script>
window.$ = window.jQuery = window.jquery = require('jquery');
    import Vue from 'vue';
    import {mapGetters} from "vuex";
    import Swal from 'sweetalert2';
    import AppConfig from "../../constants/AppConfig";
    export default {
        name: "PrestationOMNotification",
        computed: {
           // ...mapGetters(['loader']),
        },
        data(){
            return {
                payToken:this.$route.params.pay_token,
                intervale :0,
                milliSeconde:0,
                nbreSecondes:30,
                testAutomatique:true,
                paiementReussi:false,
            }
        },
        methods:{
            procederAuPaiement() {
                this.$router.go(-1);
            },

            checkStatutPaiement(){
                let api_url = AppConfig.apiUrl+"/paiement/prestation/om/"+this.payToken+"/notification";
                let self= this;
            $.ajax({
                url: api_url,
                type: "GET",
            })
            .then(function (response) {
                // console.log('response ', response)
                // handle success
                let reponse = JSON.parse(response.reponse);
                // console.log('ldflm ', reponse);
                if(response.statut == "FAILED"){
                    self.testAutomatique = false;
                        Swal.fire(
                            'Echec de Paiement',
                        reponse.message,
                        'error'
                    )
                }else if(response.statut == "SUCCESSFULL"){
                    self.paiementReussi = true
                    self.testAutomatique = false;
                    let param = {id: response.code_contrat};
                        self.$router.push({name: "PaymentSuccess", params: param});
                }else{
                        self.testAutomatique = false;
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
            }
        },

        mounted() {
            //Nous allons faire un ping sur les servers de orange jusqu'a ce que l'utilisateur ait
            // valider la transaction
            setInterval(ajaxCall, 30000);
            setInterval(progressBar, 1000);
            let self=this;

            function progressBar(){
                self.milliSeconde +=1000;
                self.intervale = (self.milliSeconde * 100)/30000;
                self.nbreSecondes -=1;

                if(self.intervale == 100 || self.loader == true){
                    self.milliSeconde =0;
                    self.intervale =0;
                    self.nbreSecondes =30;
                }
            }

            function ajaxCall() {
                //do your AJAX stuff here
                // Make a request for a user with a given ID
                if (self.testAutomatique){
                    self.checkStatutPaiement();
                }

            }
        }
    }
</script>

<style scoped>

</style>
